export const ADD_FILE_FOR_TASK = "ADD_FILE_FOR_TASK";
export const ADD_FILE_FOR_TASK_SUCCESS = "ADD_FILE_FOR_TASK_SUCCESS";
export const ADD_FILE_FOR_TASK_FAIL = "ADD_FILE_FOR_TASK_FAIL";
